// extracted by mini-css-extract-plugin
module.exports = {"applicantDetailContainer":"ApplicantDetailSidebar_applicantDetailContainer__3DkfW","spinner":"ApplicantDetailSidebar_spinner__2OBOG"};